// Import actions
import { generator } from '_/vuex/getters';

export default {
    // Bind vuex props
    vuex: {
        getters: {
            generator,
        },
    },
};
